import { dataURLtoBlob } from "./DataUrlToBlob";

const selfieDataRequest = (captured: string | null | undefined) => {
  try {
    const formData = new FormData();
    if (captured) {
      const blob = dataURLtoBlob(captured);

      if (blob) {
        formData.append("file", blob, "selfie.png");
      } else {
        throw new Error("Failed to convert base64 to Blob");
      }
    }

    formData.append("privacy", String(true));

    const ABTastyUA = JSON.parse(sessionStorage?.ABTastyUA || "{}");
    const contextData = {
      action: "Hair ...",
      os: ABTastyUA?.os
        ? ABTastyUA?.os?.name + " " + ABTastyUA?.os?.version
        : "Unknown OS",
      device: ABTastyUA?.type ?? "Unknown Device", //Desktop
      app: "Hair VTO web app",
      src: "web SDK",
      captureMethod: "Hair wizard LIQA",
      version: "1.0", //web SDK version
      type: "Photo",
      wifi: "",
      osName: ABTastyUA?.os?.name ?? "Unknown OS", //OS X
      osVersion: ABTastyUA?.os?.version ?? "Unknown OS Version", //10_15_7
      browserName: ABTastyUA?.browser?.name ?? "Unknown Browser", //Chrome
      browserVersion: ABTastyUA?.browser?.version ?? "Unknown Browser Version", //111.0.0.0
    };

    const ABTastyGeoloc = JSON.parse(sessionStorage?.ABTastyGeoloc || "{}");
    const location = {
      city: ABTastyGeoloc?.city ?? "Unknown City",
      city_id: ABTastyGeoloc?.city_id ?? "Unknown City ID",
      country_iso_code: ABTastyGeoloc?.country_iso_code ?? "Unknown Country",
      country_name: ABTastyGeoloc?.country_name ?? "Unknown Country Name",
      latitude: ABTastyGeoloc?.latitude ?? "Unknown Latitude",
      longitude: ABTastyGeoloc?.longitude ?? "Unknown Longitude",
      postal_code: ABTastyGeoloc?.postal_code ?? "Unknown Postal Code",
      state_iso_code: ABTastyGeoloc?.state_iso_code ?? "Unknown State ISO Code",
    };

    const DSOTF_LOGIN_HINT_KEY = JSON.parse(
      localStorage?.DSOTF_LOGIN_HINT_KEY || "{}"
    );
    const { secureToken: sessionId } = JSON.parse(
      localStorage?.sessionData || "{}"
    );
    const userData = {
      gti:
        (DSOTF_LOGIN_HINT_KEY?.gti || window?.globalPageData?.profile?.GTI) ??
        "0",
      loginStatus:
        DSOTF_LOGIN_HINT_KEY?.loginStatus ||
        window?.globalPageData?.profile?.lastName
          ? true
          : false,
      loyaltyId:
        (DSOTF_LOGIN_HINT_KEY?.loyaltyId ||
          window?.globalPageData?.rewards?.loyaltyId) ??
        "",
      sessionId: sessionId,
      atgId: DSOTF_LOGIN_HINT_KEY?.atgId,
    };

    formData.append(
      "metadata",
      JSON.stringify({
        userData,
        contextData,
        geolocation: location,
      })
    );
    return formData;
  } catch (error: any) {
    console.error("Error creating FormData:", error);
    return null;
  }
};

export default selfieDataRequest;
